import Loader from 'component/loader'
import React from 'react'

function SideNAvButtonGradient({
  type,
  disabled,
  label,
  processing,
  children,
  onClick,
  className,
}) {
  return (
    <button
      onClick={onClick}
      type={type || 'button'}
      className={`
        ${disabled ? 'opacity-50 cursor-not-allowed' : ''}
        text-white
        ${className}
        bg-[#F5821F]
        hover:bg-[#e07018]
        active:bg-[#d16a12]
        focus:ring-2 focus:outline-none focus:ring-[#F5821F]/40
        font-medium rounded-lg text-sm px-5 py-2.5 text-center
        transition-colors duration-150
      `}
      disabled={disabled || processing}
    >
      {processing ? <Loader /> : label || children}
    </button>
  )
}

export default SideNAvButtonGradient